declare var Enumeration: any;

let PathItemPresenterDetailEnum = {
  INTAKE: {
    stateName: 'my.majorexplorer-step',
    stateParams: {
      pageIndex: 0
    },
    text: 'Launch the Major Explorer'
  },
  CAMPUS: false,
  CHECKBOX: false,
  CHOICE: false,
  GENERIC: false,
  DETAILS: false,
  INFO: false,
  INTEREST: false,
  LISTSELECTION: false,
  METARANKING: false,
  PROGRAMS: false,
  PLACEMENTTEST: false,
  RANK: false,
  APPOINTMENT: false,
  APPOINTMENT_INVITATION: false,
  ARTICLE: false,
  TOPIC: false
};

angular
  .module('data-ng-todos')
  .constant('pathItemPresenterDetailEnum', Enumeration('pathItemPresenterDetailEnum', PathItemPresenterDetailEnum));



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/types/path_presenter_detail_enum.ts